<template>
  <v-hover v-model="buttonHovering">
    <v-col>
      <v-row :justify="justify">
        <span
          class="text-right caption font-weight-bold grey--text text--lighten-1"
          >{{ label }}
        </span>
      </v-row>
      <v-row :justify="justify" v-if="!truncate">
        <span
          class="text-center subtitle-2 font-weight-bold grey--text text--darken-3"
        >
          {{ value }}
        </span>
      </v-row>

      <v-row :justify="justify" v-if="truncate">
        <v-tooltip top max-width="220">
          <template v-slot:activator="{ on }">
            <span
              v-on="on"
              class="text-truncate text-center subtitle-2 font-weight-bold grey--text text--darken-3"
              :style="[
                customStyle
                  ? { 'max-width': customStyle }
                  : { 'max-width': '150px' },
              ]"
            >
              {{ value }}
            </span>
            <v-lazy
              :options="{ threshold: 0.6 }"
              transition="slide-x-reverse-transition"
              class="ma-n1"
            >
              <v-btn
                class="ml-3"
                v-show="showCopyButton"
                x-small
                icon
                color="blue darken-2"
                v-clipboard:copy="value"
              >
                <v-icon>mdi-content-copy</v-icon>
              </v-btn>
            </v-lazy>
          </template>
          <span>{{ value }}</span>
        </v-tooltip>
      </v-row>
    </v-col>
  </v-hover>
</template>

<script>
export default {
  props: {
    label: String,
    value: String,
    justify: String,
    truncate: Boolean,
    customStyle: String,
    showWarning: Boolean,
  },
  data() {
    return {
      showCopyButton: false,
      buttonHovering: false,
    };
  },
  watch: {
    buttonHovering(newVal) {
      this.showCopyButton = newVal;
    },
  },
  methods: {},
};
</script>